import { render, staticRenderFns } from "./circuitos.vue?vue&type=template&id=2bfbf66c&scoped=true&"
import script from "./circuitos.vue?vue&type=script&lang=js&"
export * from "./circuitos.vue?vue&type=script&lang=js&"
import style0 from "./circuitos.vue?vue&type=style&index=0&id=2bfbf66c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfbf66c",
  null
  
)

export default component.exports